export const activeRoutes = [
  // 展示页面
  {
    path: "/active/display_page",
    name: "DisplayPage",
    meta: {
      isKeepAlive: false,
      title: "展示页面",
    },
    component: () => import("@/components/display_page/index.vue"),
  },
  // 展示页面2
  {
    path: "/active/display_page_2",
    name: "DisplayPage",
    meta: {
      isKeepAlive: false,
      title: "兔年春节放假通知展示页面",
    },
    component: () => import("@/components/display_page/display_page_2.vue"),
  },

  // 问卷调查
  {
    path: "/active/questionnaire_investigation",
    name: "questionnaire_investigation",
    meta: {
      isKeepAlive: false,
      title: "调查问卷",
    },
    component: () =>
      import("@/components/questionnaire_investigation/index.vue"),
  },
  // 新引导下载界面
  {
    path: "/active/new_boot_page",
    name: "new_boot_page",
    meta: {
      isKeepAlive: false,
      title: "调查问卷-获取app",
    },
    component: () => import("@/components/new_boot_page/index.vue"),
  },
  // 下载界面
  {
    path: "/active/hyx_download",
    name: "hyx_download",
    meta: {
      isKeepAlive: false,
      title: "下载海e行",
    },
    component: () => import("@/components/hyx_download/index.vue"),
  },

  // 投票界面
  {
    path: "/active/vote",
    name: "vote_index",
    meta: {
      isKeepAlive: false,
      title: "投票",
    },
    component: () => import("@/components/vote/index.vue"),
  },
  // 投票-详细规则
  {
    path: "/active/vote_rules",
    name: "vote_rules",
    meta: {
      isKeepAlive: false,
      title: "投票详细规则",
    },
    component: () => import("@/components/vote/voteRules.vue"),
  },
  // 投票-排行榜
  {
    path: "/active/ranking_list",
    name: "ranking_list",
    meta: {
      isKeepAlive: false,
      title: "投票排行榜",
    },
    component: () => import("@/components/vote/rankingList.vue"),
  },
  // 投票-分享界面
  {
    path: "/active/vote_share",
    name: "vote_share",
    meta: {
      isKeepAlive: false,
      title: "投票-分享界面",
    },
    component: () => import("@/components/vote_share/index.vue"),
  },

  // 抽奖-主界面
  {
    path: "/active/luck_draw",
    name: "luck_draw",
    meta: {
      isKeepAlive: false,
      title: "抽奖活动",
    },
    component: () => import("@/components/luck_draw/index.vue"),
  },
  // 抽奖-中奖情况
  {
    path: "/active/winning_lottery",
    name: "winning_lottery",
    meta: {
      isKeepAlive: false,
      title: "中奖情况",
    },
    component: () => import("@/components/luck_draw/winning-lottery.vue"),
  },
  // 抽奖-联系客服
  {
    path: "/active/contact_page",
    name: "contact_page",
    meta: {
      isKeepAlive: false,
      title: "联系客服",
    },
    component: () => import("@/components/luck_draw/contact-page.vue"),
  },

  // 江海e行 年末抽奖-抽奖主页
  {
    path: "/active/yearend_lottery",
    name: "yearend_lottery",
    meta: {
      isKeepAlive: false,
      title: "抽奖活动",
    },
    component: () => import("@/components/yearend_lottery/index.vue"),
  },
  {
    path: "/active/yearend_winning_lottery",
    name: "yearend_winning_lottery",
    meta: {
      isKeepAlive: false,
      title: "中奖名单",
    },
    component: () => import("@/components/yearend_lottery/winning-lottery.vue"),
  },
  {
    path: "/active/yearend_contact_page",
    name: "yearend_contact_page",
    meta: {
      isKeepAlive: false,
      title: "联系客服",
    },
    component: () => import("@/components/yearend_lottery/contact-page.vue"),
  },
  {
    path: "/active/yearend_download_page",
    name: "yearend_download_page",
    meta: {
      isKeepAlive: false,
      title: "下载页",
    },
    component: () => import("@/components/yearend_lottery/download-page.vue"),
  },
];
